export const PageProviderSymbol = Symbol('PageProvider')
export const LogicalReflectorSymbol = Symbol('LogicalReflector')

export const name = 'pages' as const
